import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios from 'axios';
import { STORE_LOADER } from 'src/reducers/landingPage';
import { FeedbackType, STORE_FEEDBACK_REQUEST_TYPES } from 'src/reducers/feedbackRequest';

// Action creator
// Define the action creator with specific type
export const storeFeedbackTypes = (types: FeedbackType[]) => ({
  type: STORE_FEEDBACK_REQUEST_TYPES,
  feedbackTypes: types,
});

export interface DataParamType {
  fdate: string | null;
  tdate: string | null;
  // userId: string;
}

export const commonDateFormat = (actualDate: Date | null, type: string) => {

  if (actualDate === null) {
      return null;
  }

  const date = typeof (actualDate) === 'object' ? actualDate : new Date(actualDate);

  if (type === 'date' && date !== null) {

      const year = date.getFullYear();
      const month = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      const final = [day, month, year].join('/');

      return final;
  } else if (type === 'time' && date !== null) {

      const hours = `0${date.getHours()}`.slice(-2);
      const minutes = `0${date.getMinutes()}`.slice(-2);
      const seconds = `0${date.getSeconds()}`.slice(-2);
      const strTime = `${hours}:${minutes}:${seconds}`;

      return strTime;
  }
  return null;

};

export const getFeedbackTypes = (startDate: Date, endDate: Date) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

    const dataParam: DataParamType = {
      fdate: commonDateFormat(startDate, 'date'),
      tdate: commonDateFormat(endDate, 'date'),
    };

    try {
      const response = await axios({
        method: 'post',
        url: `${getState().environment.API_URL}loadOrderData?listType=fdbkapi`,
        data: dataParam,
        headers: {
          'Content-Type': 'application/json',
          sessionid: getState().user.userDetails.s || '',
        },
      });

      const feedbackData = response.data.length === 1 && response.data[0].orderno === '' 
        ? []
        : response.data;
      
      dispatch(storeFeedbackTypes(feedbackData));
    } catch (error) {
      console.error('Failed to fetch feedback types:', error);
      dispatch(storeFeedbackTypes([]));
    } finally {
      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/feedbackRequestAction.tsx